import { assertNotNullOrUndefined } from 'record-it-utils/utils/assert/assertNotNullOrUndefined';
import { NestedKeys } from 'record-it-utils/utils/utilityTypes/NestedKeys';
import { NestedKeyAccessor } from 'record-it-utils/utils/utilityTypes/NestedKeyAccessor';
import { SiteConfigFetcher } from './SiteConfigFetcher';
import { SiteConfigUtils } from './SiteConfigUtils';

export class SiteConfig {
  private config: Config | null = null;

  public async load(): Promise<void> {
    this.config = await SiteConfigFetcher.fetch();
  }

  public get<TKey extends NestedKeys<Config>>(
    key: TKey
  ): NestedKeyAccessor<Config, TKey> {
    assertNotNullOrUndefined(this.config, 'no config loaded');

    return SiteConfigUtils.getValue(this.config, key);
  }
}

export type Config = {
  ApiBaseUrl: string;
  SocketMainBaseUrl: string;
};
